/**
 * Curated Iconoir icon names offered by the IconPicker.
 *
 * Rendered as `iconoir-<name>` CSS classes, so every entry must exist in the
 * Iconoir webfont stylesheet the app loads. Keep the list small and generic —
 * it is a "sane defaults" menu for link icons, not a mirror of the full set.
 */
export const ICONOIR_ICON_NAMES = [
  "home",
  "app-window",
  "grid-plus",
  "dashboard-speed",
  "reports",
  "stats-report",
  "graph-up",
  "percentage",
  "database",
  "folder",
  "page",
  "book",
  "bookmark",
  "calendar",
  "clock",
  "mail",
  "chat-bubble",
  "phone",
  "bell",
  "user",
  "group",
  "community",
  "user-crown",
  "heart",
  "healthcare",
  "health-shield",
  "pharmacy-cross-circle",
  "activity",
  "hospital",
  "building",
  "map",
  "map-pin",
  "car",
  "truck",
  "packages",
  "dollar-circle",
  "credit-card",
  "wallet",
  "shopping-bag",
  "settings",
  "tools",
  "wrench",
  "lock",
  "shield-check",
  "key",
  "cloud",
  "server",
  "code",
  "terminal",
  "bug",
  "help-circle",
  "info-circle",
  "search",
  "star",
  "flash",
  "globe",
  "link",
  "google-drive",
] as const;

export type IconoirIconName = (typeof ICONOIR_ICON_NAMES)[number];

/** Whether a stored icon string is one this app is willing to render. */
export function isIconoirIconName(value: string): value is IconoirIconName {
  return (ICONOIR_ICON_NAMES as readonly string[]).includes(value);
}
